import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-search-Selectable',
  templateUrl: './search-Selectable.component.html',
  styleUrls: ['./search-Selectable.component.scss'],
  standalone: false,
})
export class SearchSelectableComponent implements OnInit {
  @Input() public title: string = 'Search';
  @Input() public data: any[] = [];
  @Input() public multiple: boolean = false;
  @Input() public selectOnTap: boolean = false;
  @Input() public itemTextFeild: string = 'name';
  @Input() public itemSubTextFeild: string = '';
  @Input() public itemLogoFeild: string = '';
  @Input() public itemValueFeild: string = '';
  @Input() public noImage: string = 'assets/imgs/no_image_available.png';
  @Input() public preSelected: any[] = [];
  @Output() public selectionChange = new EventEmitter<any[]>();

  public isOpen: boolean = false;
  public searchTerm: string = '';
  public selected: any[] = [];

  public ngOnInit() {}
  public ngOnChanges(changes: SimpleChanges) {
  if ((changes.preSelected || changes.data) && this.preSelected?.length && !this.selected.length) {
    this.selected = this.data.filter((item) =>
      this.preSelected.some((pre) => this.isSameItem(pre, item))
    );
  }
}
  public get filteredData(): any[] {
    if (!this.searchTerm?.trim()) {
      return this.data;
    }
    const term = this.searchTerm.toLowerCase();
    return this.data.filter((item) => {
      const label = (this.leaf(item, this.itemTextFeild) || '').toString().toLowerCase();
      const sub = this.itemSubTextFeild
        ? (this.leaf(item, this.itemSubTextFeild) || '').toString().toLowerCase()
        : '';
      return label.includes(term) || sub.includes(term);
    });
  }

  public open() {
    this.isOpen = true;
  }

  public cancel() {
    this.isOpen = false;
    this.searchTerm = '';
    this.selectionChange.emit(this.selected);
  }

  public select() {
    this.isOpen = false;
    this.searchTerm = '';
    this.selectionChange.emit(this.selected);
  }

  public toggle(item: any) {
    if (this.multiple) {
      const idx = this.selected.findIndex((s) => this.isSameItem(s, item));
      idx > -1 ? this.selected.splice(idx, 1) : this.selected.push(item);
    } else {
      this.selected = [item];
      if (this.selectOnTap) {
        this.select();
      }
    }
  }

  public isSelected(item: any): boolean {
    return this.selected.some((s) => this.isSameItem(s, item));
  }

  private isSameItem(a: any, b: any): boolean {
    if (this.itemValueFeild) {
      return this.leaf(a, this.itemValueFeild) === this.leaf(b, this.itemValueFeild);
    }
    return a === b;
  }

  public leaf = (obj: any, field: string = this.itemTextFeild): any =>
    field.split('.').reduce((value, el) => (value ? value[el] : undefined), obj);

  public get displayLabel(): string {
    if (!this.selected.length) {
      return '';
    }
    return this.selected.map((s) => this.leaf(s, this.itemTextFeild)).join(', ');
  }

  public logoOf(item: any): string {
    if (!this.itemLogoFeild) {
      return this.noImage;
    }
    const url = this.leaf(item, this.itemLogoFeild);
    return url && url !== 'null' && url !== 'undefined' ? url : this.noImage;
  }
  public get isAllSelected(): boolean {
    return this.data.length > 0 && this.selected.length === this.data.length;
  }
  public get isPartiallySelected(): boolean {
    return this.selected.length > 0 && !this.isAllSelected;
  }
  public toggleSelectAll() {
    this.selected = this.isAllSelected ? [] : [...this.data];
  }
  public trackByFn = (index: number, item: any): any => {
    return this.itemValueFeild ? this.leaf(item, this.itemValueFeild) : index;
  };
  public chipLabel(item: any): string | null {
    const primary = this.leaf(item, this.itemTextFeild);
    if (primary && primary.toString().trim()) {
      return primary;
    }
    const sub = this.itemSubTextFeild ? this.leaf(item, this.itemSubTextFeild) : null;
    if (sub && sub.toString().trim()) {
      return sub;
    }
    return null;
  }
}